





































import { Prop, Component, Vue } from "vue-property-decorator";

@Component({})
export default class Header extends Vue {
  get username() {
    return this.$store.state.user.username;
  }

  get isLoggedIn() {
    return !!this.$store.state.user.id;
  }

  get currentRoute() {
    return this.$route.path;
  }
}
